import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { ButtonReset } from '../../layout/reset';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--c-input-bg);
  border-radius: 100vmax;
`;

export const Option = styled(ButtonReset)`
  flex: 1 1 100%;
  padding: ${size(1.5)};
  border-radius: inherit;
  background-color: var(--_option-bg, transparent);
  color: var(--_option-fg, var(--c-input-text));
  font-size: ${(props) => props.theme.font.size.small};
  line-height: ${(props) => props.theme.font.size.xlarge};
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: fit-content;

  &[aria-pressed="true"] {
    --_option-bg: var(--palette-base-900);
    --_option-fg: var(--c-primary-fg);
  }

  &[aria-pressed="false"] {
    &:enabled {
      &:hover {
        --_option-bg: rgba(var(--palette-overlay-900-rgb), 0.05);
      }
    }
  }
`;
